import React from 'react';
import { useNavigate } from 'react-router-dom';
//
import { useAuthContext } from './AuthContext';
import { Loader } from '@components';

interface VerifyGuardProps {
  children: React.ReactNode;
}

const VerifyGuard = ({ children }: VerifyGuardProps) => {
  const { user, isVerified, isInitialized } = useAuthContext();

  const navigate = useNavigate();

  React.useEffect(() => {
    if (isInitialized && !user.verified && user.email && !isVerified) {
      navigate('/verify?email=' + user?.email);
    }
  }, [isInitialized, isVerified, user]);

  React.useEffect(() => {
    const _checkRedirect = () => {
      if (user && user.completed) {
        if (user.redirect && user.redirect !== '') {
          // pass the redirect as param
          navigate('/onboarding/completed', {
            state: { redirect: user.redirect },
          });
          console.log('YES');
        } else {
          navigate('/onboarding/completed');
        }
      } else {
        navigate('/onboarding');
      }
    };

    // Check in every 1 second
    // const interval = setInterval(() => {
    _checkRedirect();
    // }, 1000);

    // return () => clearInterval(interval);
  }, []);

  if (!isInitialized) {
    return <Loader />;
  }

  return <> {children} </>;
};

export default VerifyGuard;
